import route from './route'
// import components from '@/demo/locale/zh_CN/components';

export default {
  route,
  // components,
  toolbar: {
    appname: '遠傳',
    settings: '設置',
    profile: '資料',
    logout: '退出'
  },
  settings: {
    title: '主題設置',
    default: '設為默認',
    version: '版本',
    position: '元素位置',
    theme: '主題',
    dark: '暗黑主題',
    toolbarDense: '緊湊工具欄',
    navbarDense: '緊湊導航欄',
    navbarLogo: '導航欄Logo',
    settingsBtn: '設置按鈕',
    footer: '頁腳'
  },
  login: {
    titleIn: '登錄',
    titleUn: '註冊',
    singIn: '登錄',
    singUp: '註冊',
    email: 'Email',
    password: '密碼',
    confirm: '確認'
  },
  errors: {
    whoops: 'Ooops~!',
    back: '返回!',
    301: 'Moved Permanently',
    401: '未授權訪問',
    403: '禁止訪問',
    404: '找不到頁面',
    500: '伺服器錯誤'
  },
  guide: {
    description:
      'The guide page is useful for some people who entered the project for ' +
      'the first time. You can briefly introduce the features of the project. Demo is based on',
    button: '顯示引導信息'
  },
  ui: {
    switch: '切換語言',
    theme: '切換主題',
    success: '成功',
    error: '錯誤',
    warning: '警告',
    info: '提示',
    primary: '主要',
    secondary: '次要',
    default: '默認',
    accent: '強調',
    firstName: '名',
    lastName: '姓',
    email: 'E-mail'
  }
}
